/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import { useState } from 'react'
import Modal from '../Modal'
import { useServiceContext } from '../../root'

interface ConfirmRedirectModalProps {
  /** Callback when user confirms or cancels */
  updateConfirmation: (confirmed: boolean) => void
  /** Optional modal CSS classes */
  modalClasses?: {
    commentsModalClass?: string
    commentsBackdropClass?: string
  }
  /** Optional callback when modal closes */
  onClose?: () => void
}

/**
 * Confirmation modal for redirecting to study folder.
 * Used in SUWF (Single User Workflow) flows to confirm navigation away from current context.
 */
export function ConfirmRedirectModal({ updateConfirmation, modalClasses, onClose }: ConfirmRedirectModalProps) {
  const context = useServiceContext()
  const { translate } = context.service.filter
  const [isOpen, setIsOpen] = useState(true)

  const handleClose = (confirmed: boolean) => {
    setIsOpen(false)
    updateConfirmation(confirmed)
    if (onClose) {
      onClose()
    }
  }

  return (
    <Modal
      show={isOpen}
      handleClose={() => handleClose(false)}
      title={translate('ALERT')}
      size="md"
      className={`${modalClasses?.commentsModalClass || ''} theme-sandman redirect-confirmation-modal fs12`.trim()}
      isLevelTwoModal
    >
      <Modal.Body>
        <div className="roles-error-text">
          <div className="confirmation-text">{translate('STUDY_FOLDER_REDIRECT_CONFIRMATION_TEXT')}</div>
          <div className="confirmation">{translate('STUDY_FOLDER_REDIRECT_CONFIRMATION')}</div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="text-right">
          <button className="btn btn-primary text-capitalize" data-action="cancel" onClick={() => handleClose(false)}>
            {translate('NO')}
          </button>
          <button
            className="btn btn-primary text-capitalize"
            data-action="confirm"
            id="ef5b3b2c-065e-41b3-9146-daf9ac52b868"
            onClick={() => handleClose(true)}
          >
            {translate('YES')}
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  )
}

export default ConfirmRedirectModal
